export default "__VITE_ASSET__ZP_f_Xar__"